module.exports = __webpack_public_path__ + "media/banners/dx_boost-7b3227c1.png";